import { Sale } from './../models/sale.models';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VentasService {

  constructor(private http: HttpClient) { }

  getVentas(): Observable<Sale | any> {
    return this.http.get(environment.apiUrl + 'vouchers/type/sales');
  }

  eliminarVenta(id: number): Observable<string | any> {
    return this.http.delete(environment.apiUrl + 'vouchers/' + id);
  }

  /**
   * Obtiene las ventas aplicando filtros
   * @param filtros Objeto con los filtros a aplicar
   * @returns Observable con los datos filtrados
   */
  getVentasConFiltros(filtros: any): Observable<Sale | any> {
    let params = new HttpParams();
    
    // Añadir los filtros a los parámetros HTTP
    if (filtros.fechaDesde) {
      params = params.append('fechaDesde', filtros.fechaDesde);
    }
    
    if (filtros.fechaHasta) {
      params = params.append('fechaHasta', filtros.fechaHasta);
    }
    
    if (filtros.tipoComprobante) {
      params = params.append('tipoComprobante', filtros.tipoComprobante);
    }
    
    if (filtros.cliente) {
      params = params.append('cliente', filtros.cliente);
    }
    
    if (filtros.enviado !== '') {
      params = params.append('enviado', filtros.enviado ? '1' : '0');
    }
    
    if (filtros.electronico !== '') {
      params = params.append('electronico', filtros.electronico ? '1' : '0');
    }
    
    return this.http.get(environment.apiUrl + 'vouchers/type/sales', { params });
  }
}
